import React, { useEffect, useState } from "react";
import backicon from "../../../../Assets/icons/backIcon.svg";
//plus-circle.svg Minus-circle.svg
import "./index.scss";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../services/api/API";
import moment from "moment";
import { showCustomAlert } from "../../../customComponents/CustomSweetAlert";
import { GrNewWindow } from "react-icons/gr";

const VehicleGetpassDetails = () => {
  const [jobCardGetPassData, setjobCardGetPassData] = useState({});
  const [fullName, setFullName] = useState("");
  const [jodDataDetails, setDataDetails] = useState(null);
  const id = useParams()?.id;

  const fetchJobCardDetails = async () => {
    try {
      const response = await axiosInstance.get(
        `/jobcardpdfreport/jobCardGatePassDetails/${id}`
      );
      const getPassDetails = response?.data?.data;
      setjobCardGetPassData(getPassDetails);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  
console.log('jodDataDetails',jodDataDetails);
  const handelOnSubmit = async () => {
    const payload = {
      job_card_id: id,
      gate_pass_delivered_name: fullName,
    };
    try {
      const response = await axiosInstance.post(
        "/jobcardgatepass/deliveredJobCardVehicle",
        payload
      );
      showCustomAlert({
        title: "Success",
        text: "Are you sure you want to add this record?",
        confirmButtonText: "Job Card added successfully.",
        icon: "success",
        confirmButtonText: "OK",
        callback: () => {
          window.close();
        },
      });
      if(response?.data?.status===200){
        fetchJobCardDetails();
      }
      
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchJobCardDetails();
    }
  }, [id]);

  return (
    <div className="container-fuiled">
      <div className="headerColor">
        <h2 className="headerTextColor">Vehicle Gate Pass</h2>
      </div>
      <div className="custmerDetailsdiv ">
        <h5>Customer Details</h5>
      </div>
      <div className="col-12 row m-2">
        <div className="col-6">
          <div className="fw-bold">Name</div>
          <div className="fw-bold">Mobile No.</div>
          <div className="fw-bold">Address</div>
          {/* <div className="fw-bold">PinCode</div> */}
        </div>
        <div className="col-6">
          <div>{jobCardGetPassData?.customer_name || ""}</div>
          <div>{jobCardGetPassData?.mobile_no || ""}</div>
          <div>{jobCardGetPassData?.address || ""} - {jobCardGetPassData?.pincode || ""}</div>
         
        </div>
      </div>
      <div className="custmerDetailsdiv ">
        <h5>Invoice Details</h5>
      </div>
      <div className="col-12 row m-2">
        <div className="col-6">
          <div className="fw-bold">Invoice No.:</div>
          <div className="fw-bold">Date:</div>
          <div className="fw-bold">Amount:</div>
          <div className="fw-bold">Pending Amount :</div>
          <div className="fw-bold">Mode Off Payment:</div>
        </div>
        <div className="col-6">
          <div>{jobCardGetPassData?.invoice_no || ""}</div>
          <div>
            {moment(jobCardGetPassData?.invoice_date).format("DD/MM/YYYY")}
          </div>
          <div>{jobCardGetPassData?.amount_received || 0}</div>
          <div>{jobCardGetPassData?.pending_amount || 0}</div>
          <div>{jobCardGetPassData?.payment_mode || ""}</div>
        </div>
      </div>
      <div className="custmerDetailsdiv ">
        <h5>Vhichal Details</h5>
      </div>
      <div className="col-12 row m-2 ">
        <div className="col-6">
          <div className="fw-bold">Reg No. :</div>
          <div className="fw-bold">Engine No. :</div>
          <div className="fw-bold">Chassis No. :</div>
          <div className="fw-bold">Vhichal :</div>
          <div className="fw-bold">Make :</div>
          <div className="fw-bold">Model :</div>
          <div className="fw-bold">Variant :</div>
          <div className="fw-bold">Color :</div>
          <div className="fw-bold">fualType :</div>
        </div>
        <div className="col-6">
          <div>{jobCardGetPassData?.registration_no || ""}</div>
          <div>{jobCardGetPassData?.engine_no || ""}</div>
          <div>{jobCardGetPassData?.chassis_no || ""}</div>
          <div>{jobCardGetPassData?.product_name || ""}</div>
          <div>{jobCardGetPassData?.make_name || ""}</div>
          <div>{jobCardGetPassData?.model_name || ""}</div>
          <div>{jobCardGetPassData?.variant_name || ""}</div>
          <div>{jobCardGetPassData?.color_name || ""}</div>
          <div>{jobCardGetPassData?.fuel_type_name || ""}</div>
        </div>
      </div>
      <div className="border" />
      {/* <input
        type='text'/> */}
        <>
        {jobCardGetPassData?.isgate_pass_done !==1 ?(
              <>
      <div className="m-4">
        <label>
          Full Name<span className="required-asterisk">*</span>
        </label>
        <input
          readOnly={jodDataDetails?.DeliveredDetails?.status === 1 ? true : false}
          placeholder={"Enter Name"}
          disabled={false}
          required={true}
          maxLength={50}
          className={`form-control`}
          onChange={(event) => setFullName(event.target.value)}
        />
      </div>
    
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => handelOnSubmit()}
            className="submit-btn CustomeButtonStyle "
          >
            {"Submit"}
          </button>
        </div>
        </>
      )
    :
    <div className="m-3">
        <h3  style={{color:'#7BD7554'}}>Your process has been already done</h3>
    </div>
    }
      </>
    </div>
  );
};

export default VehicleGetpassDetails;
